import React from 'react';
import { Select, Button, Input } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { ResponseRule } from '../types';
import FormField from './FormField';

const { Option } = Select;

interface ResponseRuleFormProps {
  responseRule: ResponseRule;
  onUpdate: (id: string, field: keyof ResponseRule, value: any) => void;
  onRemove: (id: string) => void;
}

const ResponseRuleForm: React.FC<ResponseRuleFormProps> = ({
  responseRule,
  onUpdate,
  onRemove,
}) => {
  const hasTypeError = !responseRule.type;
  const hasOperatorError = !responseRule.operator;
  const hasValueError = !responseRule.value || responseRule.value.trim() === '';

  const isNumericField = responseRule.type === 'duration' || responseRule.type === 'responseCode';
  const hasNumericError =
    isNumericField &&
    responseRule.value &&
    responseRule.value.trim() !== '' &&
    (!/^\d+$/.test(responseRule.value.trim()) || Number(responseRule.value) < 0);

  return (
    <div key={responseRule.id}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12, marginLeft: 46 }}>
        <Select
          value={responseRule.type}
          onChange={(value) => {
            onUpdate(responseRule.id, 'type', value);
            if (value === 'duration') {
              onUpdate(responseRule.id, 'operator', 'greater than');
            } else if (value === 'responseCode') {
              onUpdate(responseRule.id, 'operator', 'greater than');
            }
          }}
          style={{
            width: 150,
            marginRight: 8,
          }}
          status={hasTypeError ? 'error' : undefined}
          placeholder="Select response attribute"
          data-test-id="response-rule-type-select"
        >
          <Option value="duration">Duration (ms)</Option>
          <Option value="responseCode">Response Code</Option>
        </Select>
        <Select
          value={responseRule.operator}
          onChange={(value) => onUpdate(responseRule.id, 'operator', value)}
          style={{
            width: 120,
            marginRight: 8,
          }}
          status={hasOperatorError ? 'error' : undefined}
          placeholder="Choose comparison"
          data-test-id="response-rule-operator-select"
        >
          {responseRule.type === 'duration' && (
            <>
              <Option value="greater than">Greater than</Option>
              <Option value="less than">Less than</Option>
            </>
          )}
          {responseRule.type === 'responseCode' && (
            <>
              <Option value="greater than">Greater than</Option>
              <Option value="less than">Less than</Option>
              <Option value="equals">Equals to</Option>
              <Option value="not equals">Not equal to</Option>
            </>
          )}
        </Select>
        <Input
          value={responseRule.value}
          onChange={(e) => onUpdate(responseRule.id, 'value', e.target.value)}
          onKeyPress={(e) => {
            if (responseRule.type === 'duration' || responseRule.type === 'responseCode') {
              const char = String.fromCharCode(e.which);
              if (!/[0-9]/.test(char)) {
                e.preventDefault();
              }
            }
          }}
          placeholder={
            responseRule.type === 'duration'
              ? 'e.g 1000ms'
              : responseRule.type === 'responseCode'
              ? 'e.g 200, 404, 500'
              : 'Enter value'
          }
          style={{
            width: 140,
            marginRight: 8,
          }}
          status={hasValueError || hasNumericError ? 'error' : undefined}
          data-test-id="response-rule-value-input"
        />
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onRemove(responseRule.id)}
          size="small"
          style={{ marginLeft: 8 }}
          data-test-id="remove-response-rule-button"
        />
      </div>

      {hasNumericError && (
        <div
          style={{
            marginLeft: 46,
            marginTop: 4,
            color: '#ff4d4f',
            fontSize: '12px',
          }}
        >
          Numeric value only
        </div>
      )}
    </div>
  );
};

export default ResponseRuleForm;
